module.exports = __webpack_public_path__ + "img/btn_link_7.bcdd534c.png";